import { Avatar, Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { BaseUser } from '../state/state';
import PhotosUtils from '../../common/utils/photos.utils';

interface OrderSuggestorInfoProps {
  suggestor: BaseUser;
}

export default function OrderSuggestorInfo({ suggestor }: OrderSuggestorInfoProps): React.JSX.Element {
  const { t } = useTranslation(['order']);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5 }}>
      <Typography variant="bodySmall" color="secondary">
        {t('order:suggested_by')}
      </Typography>
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
        <Avatar size={24} src={PhotosUtils.getUserAvatarPicture(suggestor)} variant="square" />
        <Typography variant="bodyMedium">
          {suggestor.first_name}&nbsp;{suggestor.last_name}
        </Typography>
      </Box>
    </Box>
  );
}
